// extracted by mini-css-extract-plugin
module.exports = {"container":"PagePopup_container__MP0IZ"};